import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAppDispatch from '@sportson/core-web/hooks/useAppDispatch';
import { useAppSelector } from '@sportson/core-web/hooks/useAppSelector';
import GetStoresOnhandByPartNo from '@sportson/core-web/libs/GrebbCommerceAPI/Products/GetStoresOnhandByPartNo';
import StockStatus from '@sportson/core-web/components/StockStatus';
import styled from 'libs/styled';

const Div = styled('div')``;

const Stock = ({ product, stockStatus, stockStatusStore, inStockStore, isSecondHand = false }) => {
    const selectedStoreCode = useAppSelector(({ ecommerce }) => ecommerce.stores.selected?.storeId);
    const [stores, setStores] = useState([]);
    const selectedStore = stores.find((store) => store.id === selectedStoreCode);

    const selectedStoreStockStatus = selectedStore
        ? {
              leadTime: selectedStore.on_hand.leadtime_day_count,
              stock: selectedStore.on_hand.value,
          }
        : null;

    const getStores = async () => {
        try {
            const response = await GetStoresOnhandByPartNo(product.partNo);
            // response.data[0].items is fallback for old API-data. May be removed later when new api-response is live.
            const stores = response.data[0].items || response.data;
            setStores(stores);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getStores();
    }, [product?.partNo, setStores]);

    const displayAvailability = isSecondHand ? !!selectedStore && inStockStore : !!selectedStore;

    return (
        <Div display="flex" gap="12px">
            {displayAvailability && (
                <Div display="flex" gap="6px">
                    <StockStatus
                        inStockStore={inStockStore}
                        context="store"
                        stockStatus={selectedStoreStockStatus || stockStatusStore}
                    />
                </Div>
            )}
            {!isSecondHand && <StockStatus stockStatus={stockStatus} />}
        </Div>
    );
};

export default Stock;
